import React from "react";
import { Outlet } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import StarsBackground from "./StarsBackground";
import PurpleSmoke from "./PurpleSmoke";
import TopProgress from "./TopProgress";
import VoiceChatbot from "../widgets/VoiceChatbot";

export default function Layout() {
  return (
    <div className="relative min-h-screen w-full overflow-x-hidden">
      <TopProgress />
      <StarsBackground />
      <PurpleSmoke />
      <div className="relative z-10">
        <Navbar />
        <main>
          <Outlet />
        </main>
        <Footer />
      </div>
      <VoiceChatbot />
    </div>
  );
}
